import css from "bundle-text:./frontend.sass";
import { Elm } from "./Frontend.elm";
import "../material-components-web-elm/dist/material-components-web-elm";
import "./checkout.ts";
import "./user-upload";
//import debugValues from "../../backend/data/ADDITC/values.json";

const trace = x => console.trace(x) || x;

customElements.define("x-ticketshop", class Ticketshop extends HTMLElement {
  private app? = null;

  private _id? = new URL(document.location).searchParams.get("order-id");

  private _pages? = null;
  private _tickets? = null;
  private _discounts? = null;
  private _values? = null; // trace(debugValues);

  private _locale = this.config("locale");
  private _code? = this.config("code");
  private _exhibitor? = this.config("exhibitor");
  private _loginCode? = this.config("loginCode");
  private _auth? = null;

  private _checkout? = null;
  private _crashed? = new URL(document.location).searchParams.get("crashed");
  private _loading? = null;

  private config(key, dflt = null) {
    if (this.hasAttribute(key)) return this.getAttribute(key);
    return new URL(document.location).searchParams.get(key) || dflt;
  }

  static get observedAttributes() {
    return [ "data-locale", "data-code", ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this[name.slice("data-".length)] = newValue;
  }

  public get id() {
    return this._id;
  }

  public set id(newId) {
    if (this._id !== null) {
      console.warn("property `id' can only be set initially, ignoring");
    }
    this._id = newId;
  }

  public get checkout() {
    return this._checkout;
  }

  public set checkout(newCheckout) {
    if (this._checkout !== null) {
      console.warn("property `checkout' can only be set initially, ignoring");
    }
    this._checkout = newCheckout;
  }

  public get crashed() {
    return this._crashed;
  }

  public set crashed(newCrashed) {
    if (this._crashed !== null) {
      console.warn("property `crashed' can only be set initially, ignoring");
    }
    this._crashed = newCrashed;
  }

  public get loading() {
    return this._loading;
  }

  public set loading(newLoading) {
    if (this._loading !== null) {
      console.warn("property `loading' can only be set initially, ignoring");
    }
    this._loading = newLoading;
  }

  public get code() {
    return this._code;
  }

  public set code(newCode) {
    if (this._code !== null) {
      console.warn("property `code' can only be set initially, ignoring");
    }
    this._code = newCode;
  }

  public get exhibitor() {
    return this._exhibitor;
  }

  public set exhibitor(newExhibitor) {
    if (this._exhibitor !== null) {
      console.warn("property `exhibitor' can only be set initially, ignoring");
    }
    this._exhibitor = newExhibitor;
  }

  public get api() {
    return this._api;
  }

  public set api(newApi) {
    if (this._api !== null) {
      console.warn("property `api' can only be set initially, ignoring");
    }
    this._api = newApi;
  }

  public get values() {
    return this._values;
  }

  public set values(newValues) {
    if (this._values !== null) {
      console.warn("property `values' can only be set initially, ignoring");
    }
    this._values = newValues;
  }

  public get pages() {
    return this._pages;
  }

  public set pages(newPages) {
    this._pages = newPages;
    if (this.app) this.app.ports.setPages.send(newPages);
  }

  public get locale() {
    return this._locale;
  }

  public set locale(newLocale) {
    this._locale = newLocale;
    if (this.app) this.app.ports.setLocale.send(this._locale);
  }

  public get tickets() {
    return this._tickets;
  }

  public set tickets(newTickets) {
    this._tickets = newTickets;
    if (this.app) this.app.ports.setTickets.send(this._tickets);
  }

  public get discounts() {
    return this._discounts;
  }

  public set discounts(newTickets) {
    this._discounts = newTickets;
    if (this.app) this.app.ports.setDiscounts.send(this._discounts);
  }

  constructor() {
    super();
  }

  async connectedCallback() { /*try {*/
    this._shadowRoot = this.attachShadow({ mode: "closed", });

    const style = document.createElement("style");
    style.setAttribute("type", "text/css");
    style.textContent = css;
    this._shadowRoot.appendChild(style);

    const link = document.createElement("link");
    link.setAttribute("href", "https://fonts.googleapis.com/icon?family=Material+Icons");
    link.setAttribute("rel", "stylesheet");
    this._shadowRoot.appendChild(link);

    const node = document.createElement("div");
    this._shadowRoot.appendChild(node);

    const slot = document.createElement("slot");
    slot.setAttribute("name", "checkout");
    this._shadowRoot.appendChild(slot);

    if (this._loginCode) {
      try {
        const auth = await (await fetch(
          `http://localhost:8080/public/user-account/login/callback?i=${this._loginCode}`,
          { credentials: "include",
          }
        )).json();
        const whoami = await fetch(
          `http://localhost:8080/public/user-account/whoami`,
          { credentials: "include",
          }
        );
        if (!whoami.ok) {
          this._auth = auth;
        }
      } catch (e) {
        console.info(`loginCode: ${e}`);
      }
      const url = new URL(window.location.href);
      url.search = url.search.replace(/[?&]loginCode=[^&]*/, "").replace(/^&/, "?");
      history.replaceState(null, "", `${url}`);
    }
    (() => {
      const link = document.createElement("link");
      link.setAttribute("href", "https://fonts.googleapis.com/icon?family=Material+Icons");
      link.setAttribute("rel", "stylesheet");
      document.head.append(link);
    })();
    console.log("flags", {
        values: this._values,
        pages: this._pages,
        idempotencyToken: crypto.randomUUID(),
        locale: this._locale,
        tickets: this._tickets,
        discounts: this._discounts,
        api: this._api,
        code: this._code,
        exhibitor: this._exhibitor,
        id: this._id,
        checkout: this._checkout,
        crashed: this._crashed,
        loading: this._loading,
        origin: window.location.href,
        width: this.parentElement.clientWidth,
        auth: this._auth,
      });
    this.app = Elm.Frontend.init({
      flags: {
        values: this._values,
        pages: this._pages,
        idempotencyToken: crypto.randomUUID(),
        locale: this._locale,
        tickets: this._tickets,
        discounts: this._discounts,
        api: this._api,
        code: this._code,
        exhibitor: this._exhibitor,
        id: this._id,
        checkout: this._checkout,
        crashed: this._crashed,
        loading: this._loading,
        origin: window.location.href,
        width: this.parentElement.clientWidth,
        auth: this._auth,
      },
      node,
    });
    this.app.ports.inspect.subscribe(detail =>
      this.dispatchEvent(new CustomEvent("inspect", { detail, }))
    );
    this.app.ports.submit.subscribe(detail =>
      this.dispatchEvent(new CustomEvent("submit", { detail, }))
    );
    this.app.ports.navigated.subscribe(() => window.requestAnimationFrame(() =>
      this.scrollIntoView()
    ));
    this.app.ports.mountCheckout.subscribe(checkout => {
      const node = document.createElement("x-checkout");
      node.setAttribute("slot", "checkout");
      node.brands = checkout.brands.join(" ");
      node.checkoutId = checkout.checkoutId;
      node.endpoint = checkout.endpoint;
      node.shopperResultUrl = checkout.shopperResultUrl;
      node.locale = checkout.locale;
      this.appendChild(node);
    });
    window.addEventListener("resize", () =>
      this.app.ports.setWidth.send(this.parentElement.clientWidth)
    );
  /*} catch(e) {
    console.info(e);
    throw e;
  }*/ }
});
